export default __webpack_public_path__ + "static/B06-316f3808fe1c4f8825a4781ab07f0ecd.png";